<template lang="pug">
  .wrap
    Header
    main.main
      section.home
        .posts(v-if="!error.posts")
          Post(v-for="(post, index) in posts" :post="post" :class="`post-${index}`")
          Ranking.ranking
        p(v-if="pending.posts") Cargando...
        .posts(v-if="error.posts")
          Post(v-for="(post, index) in defaultposts" :post="post" :class="`post-${index}`")
          Ranking.ranking

    Footer
</template>
<script>
import {mapState, mapActions} from 'vuex'
import Post from '@/components/Post'
import RankingNo from '@/components/RankingNo'
import Ranking from '@/components/Ranking'
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import DefaultPosts from '@/stores/defaultposts.json'

export default {
  created() {
    this.getPosts()
  },
  data(){
    return{
      defaultposts: DefaultPosts
    }
  },
  components: {
    Post,
    Ranking,
    RankingNo,
    Header,
    Footer,
  },
  computed: mapState({
    posts: state => state.posts,
    pending: state => state.pending,
    error: state => state.error
  }),
  methods: {
    ...mapActions([
      'getPosts'
    ])
  }

}
</script>
<style lang="scss" scoped>
.posts{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  .post{
    min-height: 30rem;
    overflow: hidden;
  }
  .post-0{
    grid-column: 1 / -1;
    min-height: 70vh;
  }
  .post-0 /deep/{
    h2{
      font-size: 3rem;
    }
    .excerpt{
      display: block;
    }
  }
  .post-1{
    grid-column: 3 / -1;
  }
  .post-1 /deep/{

  }
  .post-2{
    // grid-column: 1 / 3;
  }
  .ranking{
    grid-column: 1 / 3;
    grid-row: 2;
  }
  .post:last-of-type{
    grid-column: span / -1;
  }
  @media (max-width: 800px){
    grid-template-columns: repeat(1, 1fr);
    .post,
    .ranking{
      max-width: 100vw;
    }
    .post-0,
    .post-1,
    .post-2,
    .ranking{
      grid-column: 1 / -1;
    }
  }
}

</style>

